import { Code, FileJson, Image, RefreshCw, FileText, Shield, Binary, Link, Lock } from 'lucide-react';

export const tools = [
    {
        id: 'json-beautifier',
        title: 'JSON Beautifier',
        description: 'Format, validate, and minify JSON data with ease.',
        icon: FileJson,
        path: '/tools/json-beautifier',
        color: 'hsl(280, 100%, 65%)'
    },
    {
        id: 'json-compare',
        title: 'JSON Compare',
        description: 'Compare two JSON objects semantically.',
        icon: FileJson,
        path: '/tools/json-compare',
        color: 'hsl(260, 100%, 65%)'
    },
    {
        id: 'text-compare',
        title: 'Text Compare',
        description: 'Compare two text files and highlight the differences.',
        icon: Code,
        path: '/tools/text-compare',
        color: 'hsl(200, 100%, 60%)'
    },
    {
        id: 'image-compressor',
        title: 'Image Compressor',
        description: 'Compress images without losing quality. Client-side only.',
        icon: Image,
        path: '/tools/image-compressor',
        color: 'hsl(340, 100%, 60%)'
    },
    {
        id: 'image-crop',
        title: 'Image Cropper',
        description: 'Crop and resize images directly in your browser.',
        icon: Image,
        path: '/tools/image-crop',
        color: 'hsl(320, 100%, 60%)'
    },
    {
        id: 'image-converter',
        title: 'Image Converter',
        description: 'Convert images between PNG, JPG, and WebP.',
        icon: Image,
        path: '/tools/image-converter',
        color: 'hsl(300, 100%, 60%)'
    },
    {
        id: 'image-to-ico',
        title: 'Image to ICO',
        description: 'Convert images to multi-size ICO files for favicons and app icons.',
        icon: Image,
        path: '/tools/image-to-ico',
        color: 'hsl(220, 100%, 60%)'
    },
    {
        id: 'image-to-pdf',
        title: 'Image to PDF',
        description: 'Convert multiple images into a single PDF document.',
        icon: FileText,
        path: '/tools/image-to-pdf',
        color: 'hsl(0, 100%, 60%)'
    },
    {
        id: 'unit-converter',
        title: 'Unit Converter',
        description: 'Convert between common units of measurement.',
        icon: RefreshCw,
        path: '/tools/unit-converter',
        color: 'hsl(150, 100%, 40%)'
    },
    {
        id: 'json-validator',
        title: 'JSON Validator',
        description: 'Validate your JSON data and find syntax errors.',
        icon: FileJson,
        path: '/tools/json-validator',
        color: 'hsl(280, 100%, 65%)'
    },
    {
        id: 'color-picker',
        title: 'Color Picker',
        description: 'Pick colors and convert between HEX, RGB, and HSL.',
        icon: Image,
        path: '/tools/color-picker',
        color: 'hsl(10, 100%, 60%)'
    },
    {
        id: 'prompt-builder',
        title: 'Prompt Builder',
        description: 'Build high-quality prompts for AI models with interactive assistance.',
        icon: FileText,
        path: '/tools/prompt-builder',
        color: 'hsl(240, 100%, 60%)'
    },
    {
        id: 'jwt-decoder',
        title: 'JWT Decoder',
        description: 'Decode and inspect JSON Web Tokens (header, payload, signature).',
        icon: Shield,
        path: '/tools/jwt-decoder',
        color: 'hsl(250, 100%, 65%)'
    },
    {
        id: 'base64-encode-decode',
        title: 'Base64 Encode/Decode',
        description: 'Encode text to Base64 or decode Base64 strings.',
        icon: Binary,
        path: '/tools/base64-encode-decode',
        color: 'hsl(210, 100%, 60%)'
    },
    {
        id: 'url-encoder-decoder',
        title: 'URL Encode/Decode',
        description: 'Encode or decode valid URL strings.',
        icon: Link,
        path: '/tools/url-encode-decode',
        color: 'hsl(180, 100%, 65%)'
    },
    {
        id: 'hash-generator',
        title: 'Hash Generator',
        description: 'Generate MD5, SHA-1, SHA-256, and SHA-512 hashes from string data.',
        icon: Lock,
        path: '/tools/hash-generator',
        color: 'hsl(340, 100%, 60%)'
    }
];
